import { Typography } from '@mui/material'
import { Box, Theme } from '@mui/system'
import React, { ReactNode } from 'react'
import makeStyles from '@mui/styles/makeStyles'
import Delta from './Delta'
import { useStatusColor } from '../hooks'
import { MetricStatusType } from '../../../../types/Metrics'

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        padding: theme.spacing(1, 2),
        flexShrink: 0,
        borderRadius: 0,
    },
    compactContainer: {
        cursor: 'default',
    },
    label: {
        lineHeight: 1.4,
    },
    valueRow: {
        display: 'flex',
        alignItems: 'baseline',
    },
    value: {
        fontWeight: 600,
    }
}))

interface ContentProps {
    compact: boolean
    label: string
    value: string
    delta?: number
    status?: MetricStatusType
    detail?: string
    actionComponent?: ReactNode
}

const Content = ({ compact = false, label, value, delta, detail, status, actionComponent }: ContentProps) => {
    const classes = useStyles()
    const color = useStatusColor(status, delta)

    return (
        <Box className={`${classes.container} ${compact ? classes.compactContainer : ''}`}>
            <Typography variant="overline" color="textSecondary" className={classes.label}>
                {label}
            </Typography>

            <Box className={classes.valueRow}>
                <Typography variant="h5" component="span" className={classes.value} style={{ color }}>
                    {value}
                </Typography>
                <Delta delta={delta} />
            </Box>

            {
                !compact ? (
                    <Box my={1}>
                        <Typography variant="body2" color="textSecondary">
                            {detail}
                        </Typography>
                    </Box>
                ) : null
            }

            {actionComponent}
        </Box>
    )
}

export default Content